import { Instagram } from "lucide-react";
import { Logo, LogoMark } from "@/components/Logo";

const LINKS = [
  { id: "packages", label: "Packages" },
  { id: "gallery", label: "Gallery" },
  { id: "about", label: "About" },
  { id: "faq", label: "FAQ" },
  { id: "booking", label: "Book" },
];

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#090909]">
      <div className="mx-auto max-w-7xl px-5 md:px-10 py-16 md:py-20">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <Logo />
            <p className="mt-5 text-sm text-[#A3A3A3] font-light max-w-xs leading-relaxed">
              A craft cocktail bar that travels to your door. Weddings, private
              parties and brand events.
            </p>
            <p className="mt-6 text-sm text-[#A3A3A3] font-light flex items-center flex-wrap gap-3" data-testid="footer-socials">
              Follow us on our socials!
              <a
                href="https://instagram.com/estielle_thebartender"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-instagram-link"
                aria-label="Estielle on Instagram"
                className="text-[#A3A3A3] hover:text-[#D98B48] transition-colors duration-300"
              >
                <Instagram className="h-4 w-4" />
              </a>
              <a
                href="https://tiktok.com/@estielle_thebartender"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-tiktok-link"
                aria-label="Estielle on TikTok"
                className="text-[#A3A3A3] hover:text-[#D98B48] transition-colors duration-300"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4" aria-hidden="true">
                  <path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 1 1-2.59-2.59c.27 0 .53.04.78.12v-3.16a5.76 5.76 0 0 0-.78-.05 5.71 5.71 0 1 0 5.71 5.71V9.29a7.35 7.35 0 0 0 4.3 1.38V7.58a4.31 4.31 0 0 1-3.27-1.76z" />
                </svg>
              </a>
              <span className="text-[#D98B48]">estielle_thebartender</span>
            </p>
          </div>
          <div>
            <p className="eyebrow mb-5">Explore</p>
            <ul className="space-y-3">
              {LINKS.map((l) => (
                <li key={l.id}>
                  <a
                    href={`#${l.id}`}
                    data-testid={`footer-${l.id}-link`}
                    onClick={(e) => {
                      e.preventDefault();
                      const el = document.querySelector(`#${l.id}`);
                      if (el) el.scrollIntoView({ behavior: "smooth" });
                    }}
                    className="text-sm text-[#A3A3A3] hover:text-[#D98B48] transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="eyebrow mb-5">Contact</p>
            <ul className="space-y-3 text-sm text-[#A3A3A3]">
              <li data-testid="footer-email">booking@estiellethebrand.com</li>
              <li data-testid="footer-phone">(555) 013-2874</li>
              <li data-testid="footer-service-area">
                All of Saint Louis and surrounding areas, including Illinois
                (up to 25 miles outside of downtown STL)
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 border-t border-white/10 pt-8">
          <div className="flex items-center gap-3 text-[#666666]">
            <LogoMark className="h-6 w-6" />
            <span className="text-xs">© 2026 Estielle. Drink responsibly.</span>
          </div>
          <span className="text-xs text-[#666666]">Sample phone number — swap in yours.</span>
        </div>
      </div>
    </footer>
  );
}
